import QueryStringButton from 'components/QueryStringButton';
import SubmittingButton from 'components/SubmittingButton';
import * as React from 'react';
import { Button, ButtonProps } from 'semantic-ui-react';

import './styles.scss';
import {
    NormalCancelButtonParam,
    QueryStringCancelButtonParam,
    SubmittingButtonParam
} from './types';

interface Props extends ButtonProps {
    normalCancelButtonParam?: NormalCancelButtonParam;
    submittingButtonParam?: SubmittingButtonParam;
    queryStringCancelButtonParam?: QueryStringCancelButtonParam;
}

export default function SubmittingSection(props: Props): React.ReactElement {
    const {
        normalCancelButtonParam,
        queryStringCancelButtonParam = null,
        submittingButtonParam = {}
    } = props;

    const { disabled = false, namespace = null } = submittingButtonParam;

    let cancelButton;
    let submitButton;

    if (queryStringCancelButtonParam) {
        cancelButton = (
            <QueryStringButton
                params={queryStringCancelButtonParam?.params}
                buttonProps={{
                    type: 'button',
                    fluid: false,
                    basic: true,
                    primary: true
                }}
                ignoreActive={queryStringCancelButtonParam?.ignoreActive}
            >
                Cancel
            </QueryStringButton>
        );
    } else {
        cancelButton = (
            <Button
                type="button"
                onClick={normalCancelButtonParam?.onClose}
                basic
                primary
            >
                Cancel
            </Button>
        );
    }

    if (namespace) {
        submitButton = (
            <SubmittingButton
                type="submit"
                namespace={namespace}
                primary
                disabled={disabled}
            >
                Save
            </SubmittingButton>
        );
    } else {
        submitButton = (
            <Button type="submit" primary disabled={disabled}>
                Save
            </Button>
        );
    }

    return (
        <div className="submission-section">
            <div className="buttons">
                {cancelButton}
                {submitButton}
            </div>
        </div>
    );
}
